import { render, staticRenderFns } from "./imgCheckbox.vue?vue&type=template&id=48d500d4&scoped=true&"
import script from "./imgCheckbox.vue?vue&type=script&lang=js&"
export * from "./imgCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./imgCheckbox.vue?vue&type=style&index=0&id=48d500d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d500d4",
  null
  
)

export default component.exports